import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 20,
  page: 1,
  total: 0,
  totalPages: 1,
  hasMore: true,
};

export const userPackagePaginateSlice = createSlice({
  name: "userPackagePaginateSlice",
  initialState,
  reducers: {
    setUserPackagePageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setUserPackageCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setUserPackageTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setUserPackageTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setUserPackageHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    resetUserPackagePagination: (state, action) => {
      state.limit = 20;
      state.page = 1;
      state.total = 0;
      state.totalPages = 1;
      state.hasMore = true;
    },
  },
});

export const {
  setUserPackagePageLimit,
  setUserPackageCurrentPage,
  setUserPackageTotalCount,
  setUserPackageTotalPages,
  setUserPackageHasMore,
  resetUserPackagePagination,
} = userPackagePaginateSlice.actions;

export default userPackagePaginateSlice.reducer;
